import { ApiArrayGetter, apiService } from "@/services/api/apiService";
import { enhanceObjectCopy, isNotNullObject } from "@/helpers/units";

export class PatientListItem {
  "id": string | null = null;
  "dat": string | null = null;
  "text": string | null = null;

  constructor(rawData: Record<string, unknown> = {}) {
    enhanceObjectCopy(rawData, this as Record<string, unknown>);
  }
}

export const API_Contract_patient_list = ApiArrayGetter(
  {
    endpoint: "/contract/patient/list",
    method: "get",
  },
  PatientListItem
);
